// /utils/sanityImage.js
// This is a utility function to build a Sanity image URL

//this util uses auto format to return an image url that is optimized from sanity
//it also handles the case where the image has a hotspot
//and the case where the image has no dimensions

import imageUrlBuilder from '@sanity/image-url'
import sanityClient from '@/services/sanityClient'

const builder = imageUrlBuilder(sanityClient)

export function buildSanityImageUrl(image) {
  // if there is no dimensions, return the url
  if (!image?.asset?.metadata?.dimensions) {
    return image?.asset?.url
  }

  let urlBuilder = builder.image(image)

  // if there is a hotspot, apply .rect(...)
  if (image.hotspot) {
    const w = image.asset.metadata.dimensions.width
    const h = image.asset.metadata.dimensions.height

    urlBuilder = urlBuilder.rect(
      parseInt(image.crop.left * w),
      parseInt(image.crop.top * h),
      parseInt(image.hotspot.width * w),
      parseInt(image.hotspot.height * h),
    )
  }

  // add the parameters we want for optimization
  return urlBuilder
    .fit('max')
    .auto('format')
    .quality(50)
    .url()
}
